"use client";
import t, { useRef as n } from "react";
import "./index.es16.js";
import "./index.es17.js";
import "./index.es18.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import "./index.es23.js";
import "./index.es24.js";
import "./index.es25.js";
import "./index.es26.js";
import "./index.es27.js";
import "./index.es28.js";
import "./index.es29.js";
import c from "./index.es30.js";
import "./index.es31.js";
import "./index.es32.js";
import "./index.es33.js";
import "./index.es34.js";
import "./index.es35.js";
import "./index.es36.js";
import "./index.es37.js";
import "./index.es38.js";
import f from "./index.es49.js";
import { HomeLinks as a } from "./index.es60.js";
import u from "./index.es61.js";
import s from "./index.es62.js";
const N = ({
  title: m,
  subjects: o,
  links: e,
  subjectGroups: i,
  subjectsTitle: p,
  hash: l
}) => {
  const r = n(null);
  return f(r, l), /* @__PURE__ */ t.createElement("div", { ref: r }, /* @__PURE__ */ t.createElement(c, null, m), /* @__PURE__ */ t.createElement(s, { subjects: o, title: p }), /* @__PURE__ */ t.createElement(u, { subjectGroups: i }), /* @__PURE__ */ t.createElement(a, { links: e }));
};
export {
  N as default
};
//# sourceMappingURL=index.es2.js.map
